import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import Modal from "../common/Modal";

interface BoldOfferModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const BoldOfferModal: React.FunctionComponent<BoldOfferModalProps> = ({
  isOpen,
  onClose,
}) => {
  const [hubSpotReady, setHubSpotReady] = useState(false);

  useEffect(() => {
    if (hubSpotReady) {
      return;
    }

    let interval: number;

    interval = window.setInterval(() => {
      if ((window as any).hbspt) {
        setHubSpotReady(true);
        window.clearInterval(interval);

        (window as any).hbspt.forms.create({
          region: "na1",
          portalId: "7620271",
          formId: "8cc0600c-622e-463a-ad88-9a89c1aae7a6",
          target: "#bold-offer-form",
        });
      }
    }, 100);

    return () => {
      if (interval) {
        window.clearInterval(interval);
      }
    };
  }, [hubSpotReady]);

  return (
    <>
      <Helmet>
        <script async src="https://js.hsforms.net/forms/embed/v2.js"></script>
      </Helmet>
      <Modal show={isOpen} handleClose={onClose}>
        <div tw="mb-6">
          <div tw="font-semibold font-title">Request a demo</div>
          <div>Get 50% off your first month of ProsperStack</div>
        </div>
        <div id="bold-offer-form" />
      </Modal>
    </>
  );
};

export default BoldOfferModal;
